import { DocumentNode, gql } from '@apollo/client';
import { Button, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { ConfirmDialog } from '@/components/ConfirmDialog';
import { ECommunityVisibility } from '@/graphql-types/globalTypes';
import { useEditGroupVisibility } from '@/hooks/useEditGroupVisibility/useEditGroupVisibility';

import { HideGroupButton_GroupFragment } from './graphql-types/HideGroupButton_GroupFragment';

export const HideGroupButton: React.FC<{
  group: HideGroupButton_GroupFragment;
}> & {
  groupFragment: DocumentNode;
} = ({ group }) => {
  const { hideGroup, unhideGroup, canUnhideGroup } =
    useEditGroupVisibility(group);

  const confirmDialog = useDisclosure();

  return (
    <>
      {group.settings.communityVisibility === ECommunityVisibility.HIDDEN ? (
        <Button onClick={unhideGroup} isDisabled={!canUnhideGroup}>
          Unhide
        </Button>
      ) : (
        <Button
          onClick={
            group.subgroups.totalCount > 0
              ? confirmDialog.onOpen
              : hideGroup
          }
          variant="outline"
          colorScheme="gray"
        >
          Hide
        </Button>
      )}
      <ConfirmDialog
        title="Hiding this group will also hide all its subgroups"
        body={`You may currently have subgroups that have less strict permissions than the ones you've selected for the parent. Confirming hiding this group will also hide all its subgroups.`}
        onConfirm={hideGroup}
        isOpen={confirmDialog.isOpen}
        onClose={confirmDialog.onClose}
        confirmButtonText="Confirm"
      />
    </>
  );
};
HideGroupButton.groupFragment = gql`
  fragment HideGroupButton_GroupFragment on Group {
    _id
    settings {
      communityVisibility
    }
    subgroups(input: $subgroupsInput) {
      totalCount
    }
    ...useEditGroupVisibility_GroupFragment
  }
  ${useEditGroupVisibility.groupFragment}
`;
